import { Button, Input, InputNumber } from "antd";
import { useEffect, useState } from "react";

// Components
import CircleDot from "../icons/CircleDot";
import SquareCheck from "../icons/SquareCheck";
import { APIs } from "../../constants/api.constants";
import RadioQuestion from "./questions/RadioQuestion";
import CheckboxQuestion from "./questions/CheckboxQuestion";
import ParagraphQuestion from "./questions/ParagraphQuestion";
import { postRequest } from "../../services/ApiService";

// Style
import "../../assets/assessment.css";

const CreateAssessment = ({ episodeId, closeModal, removeCreateForm }) => {
  const [id, setId] = useState(0);
  const [data, setData] = useState({});
  const [title, setTitle] = useState("");
  const [error, setError] = useState(false);
  const [description, setDescription] = useState("");
  const [passedPercentage, setPassedPercentage] = useState(0);
  const [questions, setQuestions] = useState([]);

  const addQuestion = (type) => {
    setId(id + 1);
    setQuestions([
      {
        id: id + 1,
        type: type,
        question: {},
      },
      ...questions,
    ]);
  };

  const deleteHanlder = (id) => {
    const oldSet = questions.filter((item) => {
      return item.id !== id;
    });
    setQuestions(oldSet);
  };

  const questionHandler = (id, question) => {
    const updateQuestions = questions.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          question: question,
        };
      } else {
        return item;
      }
    });
    setQuestions([...updateQuestions]);
  };

  const submitHandler = () => {
    if (
      data.title &&
      data.assessment_question.length > 0
    ) {
      setError(false);
      data.assessment_question = data.assessment_question.reverse()
      postRequest(APIs.assessment, data).then(() => closeModal());
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    if (
      data.title &&
      data.passed_percentage &&
      data.assessment_question.length > 0
    ) {
      setError(false);
    }
  }, [data]);

  useEffect(() => {
    const questionSet = questions.map((item) => {
      if (item.question.title) {
        return item.question;
      }
    });

    setData({
      passed_percentage: +passedPercentage,
      is_completion: false,
      title: title,
      episode: episodeId,
      description: description,
      assessment_question: [...questionSet],
    });
  }, [title, episodeId, questions]);

  return (
    <div>
      <div className = "p-2">
        <span>Assessment Title</span>
        <Input
          placeholder="Input Title"
          className="w-100percent"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div className = "p-2">
        <span>Assessment Description</span>
        <Input 
          placeholder="Input Description"
          className="w-100percent"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <div className = "p-2 mb-4">
        <span>Passed Percentage</span>
        <InputNumber
          placeholder="Input Percentage"
          className="w-100percent"
          min={0}
          max={100}
          value={passedPercentage}
          onChange={(e) => setPassedPercentage(e)}
        />
      </div>

      <div className="assessment">
        <div className="h-auto d-flex border rounded-sm mb-2 justify-content-center align-items-center flex-row p-1 shadow-sm">
          <CircleDot
              height="20"
              width="20"
              className="mx-3 pointer"
              onClick={() => addQuestion("radio")}
          />
          <SquareCheck
              height="20"
              width="20"
              className="mx-3 pointer"
              onClick={() => addQuestion("checkbox")}
          />
          <h4 className="mx-3 pointer fw-bold mb-0" onClick={() => addQuestion("input")}>T</h4>
        </div>

        <div className="assessment_questions">
          {questions.map((item) => {
            if (item.type === "radio") {
              return (
                <RadioQuestion
                  key={item.id}
                  questionId={item.id}
                  questionHandler={questionHandler}
                  onDelete={() => deleteHanlder(item.id)}
                />
              );
            }
            if (item.type === "checkbox") {
              return (
                <CheckboxQuestion
                  key={item.id}
                  questionId={item.id}
                  questionHandler={questionHandler}
                  onDelete={() => deleteHanlder(item.id)}
                />
              );
            }
            if (item.type === "input") {
              return (
                <ParagraphQuestion
                  key={item.id}
                  questionId={item.id}
                  questionHandler={questionHandler}
                  onDelete={() => deleteHanlder(item.id)}
                />
              );
            }
          })}

        </div>

        {error && (
          <div className="text-danger text-center mb-4">
            <strong>Title, passed percentage and question can not be empty.</strong>
          </div>
        )}

        <div className="d-flex justify-content-end">
          <Button
            type="secondary"
            className="mt-4"
            onClick={() => removeCreateForm()}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            className="ml-3 btn btn-success mt-4"
            onClick={submitHandler}
            disabled={
              data?.assessment_question?.length === 0 ||
              (data?.assessment_question?.length &&
                data?.assessment_question[0] === undefined)
            }
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateAssessment;
